import type { App } from 'vue';
import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { staticRoutes } from './staticRoutes';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { setupBeforeEach } from './beforeEach';
import { setupAfterEach } from './afterEach';

/** 顶部进度条配置 */
export const configureNProgress = () => {
  NProgress.configure({
    easing: 'ease',
    speed: 600,
    showSpinner: false,
    parent: 'body'
  });
};

// 动态路由将从 JSON 文件加载

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_ROUTE_URL),
  routes: staticRoutes,
  scrollBehavior: () => ({ top: 0 })
});

export function initRouter(app: App<Element>): void {
  configureNProgress();
  setupBeforeEach(router);
  setupAfterEach(router);
  app.use(router);
}
